<div #box 
  class="resizable-draggable" 
  [style]="style"
  [class.active]="status === 1 || status === 2" (mousedown)="setStatus($event, 2)"
  (window:mouseup)="setStatus($event, 0)">
  <ng-content></ng-content>
  <ng-container *ngIf="debug">
    <span>{{ status | json }}</span>
    <span>{{ width | number:'1.0-0' }}px</span>
    <span>{{ height | number:'1.0-0' }}px</span>
    <span>({{left}}, {{top}})</span>
  </ng-container>
  <div *ngIf="resizeable" [hidden]="!showControls" class="resize-action" (mousedown)="setStatus($event, 1)"></div>
</div>